<script>
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";
  import Home from "./routes/Home.svelte";
</script>

<Header />
<main>
  <Home />
</main>
<Footer />
